import { FC, useMemo } from 'react'

import useAlertPurchase from '@hook/alerts/use-alert-purchase'
import useTable from '@hook/shared/use-table'

import TableGridCollpsePurchaseProcess from './item-collapse-process'

const TableGridBodyPurchaseProcess: FC = () => {
  const { data: rows } = useTable()
  const { data } = useAlertPurchase()

  const group = useMemo(() => {
    let purchases: any[] = []
    const rowsDistinct = data
      .map(item => item['info-id'])
      .filter((value, index, self) => self.indexOf(value) === index)
    for (const rows of rowsDistinct) {
      purchases = [...purchases, data.filter((x: any) => x.id === rows)]
    }
    return rowsDistinct
  }, [data])

  return (
    <tbody>
      {rows.data.length === 0 ? (
        <tr>
          <td colSpan={12} align="center">
            Dados não encontrados
          </td>
        </tr>
      ) : (
        group.map(value => (
          <>
            <TableGridCollpsePurchaseProcess filterDate={value} />
          </>
        ))
      )}
    </tbody>
  )
}
export default TableGridBodyPurchaseProcess
